








































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { IProduct } from '~/types/fightcamp';
import FCImage from '~/components/FCImage.vue';
import { useModal } from '~/composables/useModal';

interface CardProduct extends IProduct {
  tag?: string;
}

export default defineComponent({
  name: 'AccessoryGroupCard',
  components: {
    FCImage,
  },
  props: {
    product: {
      type: Object as PropType<CardProduct>,
      required: true,
    },
  },
  setup(props) {
    // @ts-ignore
    const { $store } = useNuxtApp();
    const shippingRestricted = computed(() => $store.getters.itemHasShippingRestrictions(props.product.id));

    function openLightbox(item: CardProduct) {
      const { modalShow } = useModal({
        component: () => import('~/components/FCLightBox.vue'),
        componentProps: { item },
        modalProps: {
          componentName: 'FCLightBox',
          classes: 'modal-border-radius',
        },
      });

      modalShow();
    }

    function addItemToCart(itemId: string) {
      if (shippingRestricted.value) return;

      $store.dispatch('insertItemToCart', {
        id: itemId,
        type: 'equip',
        disableDrawer: true,
        delay: true,
      });
    }

    return {
      productId: computed(() => (props.product.variantId ? props.product.variantId : props.product.id)),
      openLightbox,
      addItemToCart,
      shippingRestricted,
      ctaText: computed(() => (shippingRestricted.value ? 'Not Available in Your Area' : 'Add to cart >')),
    };
  },
});
